import { Alert, Button, Icon, Popover } from 'AWS-UI-Components-React';
import React from 'react';

import { REPORT_TYPE } from '../../constants/report_type';
import { MONTH_MAP } from '../../utils/date-utils';
import { computeRequestPayloads } from '../../utils/payload';
import { AccuracyReport } from '../reports/accuracy_report';
import { AsinMetricReport } from '../reports/asin_metrics/asin_metric_report';
import { BridgingReport } from '../reports/bridging/bridging_report';
import { ComponentReportContainer } from '../reports/component_report_container';
import { FLCPAccuracyReport } from '../reports/flcp/flcp_accuracy_report';
import { ForecastAttributionReport } from '../reports/forecast_attribution_report';
import { PLReport } from '../reports/pl_report';
import { TrendReportContainer } from '../reports/trend_report_container';
import { AccuracyTable } from './accuracy_table';
import { AccuracyTrend } from './accuracy_trend';

export class AccuracyContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadData: false,
      saveReport: false,
    };
  }

  onDownloadData = () => {
    this.setState({ downloadData: true });
  };

  beginSave = () => {
    this.setState({ saveReport: true });
  };

  resetButtons = () => {
    this.setState({ downloadData: false, saveReport: false });
  };

  formatDate = (time) => {
    let timeFrames = time.split(',');
    let formatedFrame = [];
    for (let timeFrame of timeFrames) {
      if (timeFrame.includes('/')) {
        formatedFrame.push(MONTH_MAP[timeFrame.slice(5)] + '-' + timeFrame.slice(2, 4));
      } else if (timeFrame.includes('Q')) {
        formatedFrame.push(timeFrame.slice(4) + '-' + timeFrame.slice(2, 4));
      } else {
        formatedFrame.push(timeFrame);
      }
    }
    return formatedFrame.join(', ');
  };

  reportSubmitted = () => {
    return (
      Object.keys(this.props.payload).length &&
      this.props.submitted === true &&
      this.props.columnsJson &&
      this.props.hierarchy
    );
  };

  getCPRefreshDisplay = (snapshots) => {
    const snapshotNames = [];
    const concat = [];
    for (let i = 0; i < snapshots.length; i++) {
      if (snapshots[i].cpRefreshTimestamp) {
        snapshots[i].name === this.props.liveSnapshotConfig.name
          ? snapshotNames.push('live')
          : snapshotNames.push(snapshots[i].name);
        concat.push(
          <div key={i}>{snapshotNames[i] + ' : ' + this.getCPRefreshTimeFormat(snapshots[i].cpRefreshTimestamp)}</div>
        );
      }
    }

    return concat.length ? <div> {concat} </div> : <div> live : {this.getCPRefreshTimestamp()} </div>;
  };

  getCPRefreshTimestamp = () => {
    const { liveSnapshotConfig } = this.props;
    const cpRefreshTimestamp = liveSnapshotConfig
      ? this.getCPRefreshTimeFormat(liveSnapshotConfig.cpRefreshTimestamp)
      : undefined;
    return cpRefreshTimestamp ? cpRefreshTimestamp : '';
  };

  getCPRefreshTimeFormat = (timestamp) => {
    return new Date(timestamp).toLocaleString('en-US', { timeZoneName: 'short' });
  };

  getAccuracyDriversDisabled = () => {
    return this.props.snapshots.length > 1 || this.props.nonAggregatedPayloads.length > 0;
  };

  displayAccuracyDrivers = () => {
    return this.hasAccessToFeature('accuracy-drivers') && !this.getAccuracyDriversDisabled();
  };

  hasAccessToFeature = (feature) => {
    return (this.props.featureList || []).includes(feature);
  };

  summaryMapKeys = () => {
    return ['firstCpAvAccuracy', 'lastCpAvAccuracy', 'firstCpNvAccuracy', 'lastCpNvAccuracy'];
  };

  AccuracyTable = () => {
    return (
      <AccuracyTable
        user={this.props.user}
        identity={this.props.identity}
        featureList={this.props.featureList}
        payload={this.props.payload}
        snapshots={this.props.snapshots}
        onSaveReport={this.props.onSaveReport}
        columnSetsToLoad={this.props.columnSetsToLoad}
        columnSetOverridesToLoad={this.props.columnSetOverridesToLoad}
        reportsList={this.props.reportsList}
        columnsJson={this.props.columnsJson}
        hierarchy={this.props.hierarchy}
        onLoadDone={this.props.onLoadDone}
        resetButtons={this.resetButtons}
        downloadData={this.state.downloadData}
        saveReport={this.state.saveReport}
        formatDate={this.formatDate}
        appConfig={this.props.appConfig}
        savedPreferences={this.props.savedPreferences}
        onSavePreferences={this.props.OnSavePreferences}
        nonAggregatedPayloads={this.props.nonAggregatedPayloads}
        nonAggregatedFlags={this.props.nonAggregatedFlags}
        accuracyDriversDisabled={this.getAccuracyDriversDisabled()}
        marketplaceItems={this.props.marketplaceItems}
      />
    );
  };

  PLReport = () => {
    const key = JSON.stringify(this.props.payload);
    return (
      <AccuracyReport
        key={key}
        viewComponent={PLReport}
        snapshots={this.props.snapshots}
        liveSnapshot={this.props.liveSnapshotConfig}
        requestPayloads={computeRequestPayloads(
          this.props.payload,
          this.props.snapshots,
          this.props.nonAggregatedFlags,
          this.props.marketplaceItems
        )}
        columnsJson={this.props.columnsJson}
        onLoadDone={this.props.onLoadDone}
        downloadData={this.state.downloadData}
        saveReport={this.state.saveReport}
        onSaveReport={this.props.onSaveReport}
        resetButtons={this.resetButtons}
        payload={this.props.payload}
        reportsList={this.props.reportsList}
        user={this.props.user}
        columnSetsToLoad={this.props.columnSetsToLoad}
        columnSetOverridesToLoad={this.props.columnSetOverridesToLoad}
        savedPreferences={this.props.savedPreferences}
        onSavePreferences={this.props.OnSavePreferences}
      />
    );
  };

  ForecastAttributionReport = () => {
    const key = JSON.stringify(this.props.payload);
    return (
      <AccuracyReport
        key={key}
        viewComponent={ForecastAttributionReport}
        snapshots={this.props.snapshots}
        liveSnapshot={this.props.liveSnapshotConfig}
        requestPayloads={computeRequestPayloads(
          this.props.payload,
          this.props.snapshots,
          this.props.nonAggregatedFlags,
          this.props.marketplaceItems
        )}
        columnsJson={this.props.columnsJson}
        onLoadDone={this.props.onLoadDone}
        downloadData={this.state.downloadData}
        saveReport={this.state.saveReport}
        onSaveReport={this.props.onSaveReport}
        resetButtons={this.resetButtons}
        payload={this.props.payload}
        reportsList={this.props.reportsList}
        user={this.props.user}
        columnSetsToLoad={this.props.columnSetsToLoad}
        columnSetOverridesToLoad={this.props.columnSetOverridesToLoad}
        savedPreferences={this.props.savedPreferences}
        onSavePreferences={this.props.OnSavePreferences}
      />
    );
  };

  ComponentReport = () => {
    const key = JSON.stringify(this.props.payload);
    return (
      <AccuracyReport
        key={key}
        viewComponent={ComponentReportContainer}
        snapshots={this.props.snapshots}
        liveSnapshot={this.props.liveSnapshotConfig}
        requestPayloads={computeRequestPayloads(
          this.props.payload,
          this.props.snapshots,
          this.props.nonAggregatedFlags,
          this.props.marketplaceItems
        )}
        columnsJson={this.props.columnsJson}
        onLoadDone={this.props.onLoadDone}
        downloadData={this.state.downloadData}
        saveReport={this.state.saveReport}
        onSaveReport={this.props.onSaveReport}
        resetButtons={this.resetButtons}
        payload={this.props.payload}
        reportsList={this.props.reportsList}
        user={this.props.user}
        columnSetsToLoad={this.props.columnSetsToLoad}
        columnSetOverridesToLoad={this.props.columnSetOverridesToLoad}
        savedPreferences={this.props.savedPreferences}
        onSavePreferences={this.props.OnSavePreferences}
        oppuHierarchy={this.props.hierarchy}
        displayAccuracyDrivers={this.displayAccuracyDrivers()}
        featureList={this.props.featureList}
        summaryMapKeys={this.summaryMapKeys()}
      />
    );
  };

  BridgingReport = () => {
    const { snapshots } = this.props;
    const bridgingSnapshotId =
      snapshots && snapshots.length && snapshots[0].bridgingParameters && snapshots[0].bridgingParameters.snapshotId;
    let payload = {
      ...this.props.payload,
      snapshotId: bridgingSnapshotId ? bridgingSnapshotId : this.props.payload.snapshotId,
    };
    const key = JSON.stringify(payload);

    return (
      <BridgingReport
        key={key}
        snapshots={this.props.snapshots}
        liveSnapshot={this.props.liveSnapshotConfig}
        requestPayloads={computeRequestPayloads(payload, this.props.snapshots, this.props.nonAggregatedFlags, this.props.marketplaceItems)}
        onLoadDone={this.props.onLoadDone}
        productLines={this.props.productLines}
        payload={payload}
        reportsList={this.props.reportsList}
        user={this.props.user}
        marketplaceItems={this.props.marketplaceItems}
        featureList={this.props.featureList}
      />
    );
  };

  TrendReport = () => {
    const key = JSON.stringify(this.props.payload);
    return (
      <AccuracyReport
        key={key}
        viewComponent={TrendReportContainer}
        snapshots={this.props.snapshots}
        liveSnapshot={this.props.liveSnapshotConfig}
        requestPayloads={computeRequestPayloads(
          this.props.payload,
          this.props.snapshots,
          this.props.nonAggregatedFlags,
          this.props.marketplaceItems
        )}
        columnsJson={this.props.columnsJson}
        onLoadDone={this.props.onLoadDone}
        downloadData={this.state.downloadData}
        saveReport={this.state.saveReport}
        onSaveReport={this.props.onSaveReport}
        resetButtons={this.resetButtons}
        payload={this.props.payload}
        reportsList={this.props.reportsList}
        user={this.props.user}
        columnSetsToLoad={this.props.columnSetsToLoad}
        columnSetOverridesToLoad={this.props.columnSetOverridesToLoad}
        savedPreferences={this.props.savedPreferences}
        onSavePreferences={this.props.OnSavePreferences}
        appConfig={this.props.appConfig}
        featureList={this.props.featureList}
        summaryMapKeys={this.summaryMapKeys()}
      />
    );
  };

  asinMetricReportHeader = () => {
    return (
      <div className="awsui-util-container-header">
        <div className="awsui-util-action-stripe">
          <div className="awsui-util-action-stripe-title">
            <div className="awsui-util-font-size-2">
              {this.props.payload.report.toUpperCase()} REPORT - {this.formatDate(this.props.payload.timeFrame)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  reportSubmittedHeader = () => {
    return (
      <div className="awsui-util-container-header">
        <div className="awsui-util-action-stripe">
          <div className="awsui-util-action-stripe-title">
            <div className="awsui-util-font-size-2">
              {this.props.payload.report.toUpperCase()} REPORT - {this.formatDate(this.props.payload.timeFrame)}
            </div>
          </div>
          <div className="awsui-util-action-stripe-group">
            <div className="awsui-util-action-stripe-title">
              <div className="awsui-util-font-size-2">
                {this.props.snapshots && (
                  <Popover
                    size="medium"
                    position="top"
                    triggerType="text"
                    dismissButton={false}
                    content={
                      <span className="awsui-util-font-size-2">{this.getCPRefreshDisplay(this.props.snapshots)}</span>
                    }
                  >
                    CP Refresh Timestamp <Icon name="status-info" />
                  </Popover>
                )}
              </div>
            </div>
            <Button
              text="Download"
              variant="normal"
              disabled={!this.props.loadDone || this.state.saveReport}
              loading={this.state.downloadData}
              onClick={this.onDownloadData}
              data-cy="report-download-button"
            />
            <Button
              text="Save"
              variant="primary"
              disabled={!this.props.loadDone || this.state.downloadData || this.props.payload.report === 'trend'}
              loading={this.state.saveReport}
              onClick={this.beginSave}
              data-cy="report-save-button"
            />
          </div>
        </div>
      </div>
    );
  };

  reportNotSubmittedHeader = () => {
    return (
      <div className="awsui-util-container-header">
        <div className="awsui-util-action-stripe">
          <div className="awsui-util-action-stripe-group">
            <div className="awsui-util-font-size-2">Accuracy Analytics</div>
          </div>
          {this.props.snapshots && (
            <Popover
              size="medium"
              position="top"
              triggerType="text"
              dismissButton={false}
              content={<span className="awsui-util-font-size-2">live : {this.getCPRefreshTimestamp()}</span>}
            >
              CP Refresh Timestamp <Icon name="status-info" />
            </Popover>
          )}
        </div>
      </div>
    );
  };

  AccuracyTrend = () => {
    return (
      <AccuracyTrend
        user={this.props.user}
        payload={this.props.payload}
        snapshots={this.props.snapshots}
        appConfig={this.props.appConfig}
        monthMap={MONTH_MAP}
        downloadData={this.state.downloadData}
        resetButtons={this.resetButtons}
        onLoadDone={this.props.onLoadDone}
      />
    );
  };

  AsinMetricReport = () => {
    return (
      <AsinMetricReport
        user={this.props.user}
        identity={this.props.identity}
        featureList={this.props.featureList}
        payload={this.props.payload}
      />
    );
  };

  FLCPAccuracyReport = () => {
    return (
      <FLCPAccuracyReport
        user={this.props.user}
        identity={this.props.identity}
        featureList={this.props.featureList}
        payload={this.props.payload}
        updateTools={this.props.updateTools}
      />
    );
  };

  render() {
    if (this.reportSubmitted()) {
      return (
        <div>
          {this.props.payload.report.toUpperCase() === REPORT_TYPE.COMPONENT && (
            <div className="awsui-util-container">
              {this.reportSubmittedHeader()}
              {this.hasAccessToFeature('componentReportNew') ? this.ComponentReport() : this.AccuracyTable()}
            </div>
          )}
          {this.props.payload.report.toUpperCase() === REPORT_TYPE.PL && (
            <div className="awsui-util-container">
              {this.reportSubmittedHeader()}
              {this.hasAccessToFeature('plReportNew') ? this.PLReport() : this.AccuracyTable()}
            </div>
          )}
          {this.props.payload.report.toUpperCase() === REPORT_TYPE.FORECAST && (
            <div className="awsui-util-container">
              {this.reportSubmittedHeader()}
              {this.ForecastAttributionReport()}
            </div>
          )}
          {this.props.payload.report.toUpperCase() === REPORT_TYPE.TREND && (
            <div className="awsui-util-container">
              {this.reportSubmittedHeader()}
              {this.hasAccessToFeature('trendReportNew') ? this.TrendReport() : this.AccuracyTrend()}
            </div>
          )}
          {this.props.payload.report.toUpperCase() === REPORT_TYPE.ASIN_METRICS_REPORT && (
            <div className="awsui-util-container">
              {this.asinMetricReportHeader()}
              {this.AsinMetricReport()}
            </div>
          )}
          {this.props.payload.report.toUpperCase() === REPORT_TYPE.BRIDGING_FACTORS && (
            <div className="awsui-util-container">{this.BridgingReport()}</div>
          )}
          {this.props.payload.report.toUpperCase() === REPORT_TYPE.FLCP_ACCURACY && this.FLCPAccuracyReport()}
        </div>
      );
    } else if (Object.keys(this.props.payload).length && this.props.submitted) {
      return (
        <div className="awsui-util-container">
          {this.reportNotSubmittedHeader()}
          <Alert type="success" header="Report Calculating" content="Loading configurations..." />
        </div>
      );
    } else {
      return (
        <div className="awsui-util-container">
          {this.reportNotSubmittedHeader()}
          <Alert header="No Reports to Show" content="Create a report using the sidebar to begin." />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/content/accuracy_content.jsx